module.exports = __webpack_public_path__ + "./static/img/media.68107c684828a92545dde056c080f8a4.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/media.png
// module id = ./client/src/assets/fontawesome/media.png
// module chunks = 0